// extracted by mini-css-extract-plugin
export default {"item":"Card_item__jk76A","bg":"Card_bg__IoHW6","date":"Card_date__d-TWF","topItem":"Card_topItem__5R2+h","eventType":"Card_eventType__ndp9Z","time":"Card_time__x2LmE"};